angular.module('satv.playlist.pitch')
.controller('PitchNoteModalFormCtrl', ['$scope', 'PitchNote', 'Pitch', function($scope, PitchNote, Pitch) {

    $scope.submit = function(pitch, model) {

        PitchNote.save({
            id: model.id,
            pitch: pitch.hash,
            name: model.name,
            pitch_note_text: model.text
        }, function(resp) {
            $scope.$close(true, resp.data);
        }, function(resp) {
            if (resp.data) {
                $scope.errors = resp.data.errors;
            }
        });

    };

    $scope.tinymceOptions = {
       menubar: false,
       plugins: 'paste link code',
       toolbar: 'bold italic underline | link paste code',
       elementpath: false
   };

}]);



// WEBPACK FOOTER //
// ./vendor/sonyatv/playlistpitchclientbundle/Resources/js/angular/controllers/PitchNoteModalFormCtrl.js